
(function () {
    var savedConfig = sessionStorage.getItem("__ADMINTO_CONFIG__");

    var html = document.getElementsByTagName("html")[0];

    //  Default Config Value
    var defaultConfig = {
        theme: "light",

        layout: {
            mode: "fluid",
        },

        topbar: {
            color: "light",
        },

        menu: {
            color: "light",
        },

        // This option for only vertical (left Sidebar) layout
        sidenav: {
            size: "default",
        },
    };


    var config = Object.assign(JSON.parse(JSON.stringify(defaultConfig)), {});

    var userTheme = html.getAttribute('data-user-theme');

    if (userTheme && userTheme !== '') {
        // User has DB preference - trust server-rendered data-bs-theme
        config['theme'] = userTheme;
        config['menu']['color'] = userTheme;
        config['topbar']['color'] = userTheme;
        // Sync sessionStorage to match DB (prevents stale override)
        if (savedConfig !== null) {
            var saved = JSON.parse(savedConfig);
            saved.theme = userTheme;
            if (saved.menu) saved.menu.color = userTheme;
            if (saved.topbar) saved.topbar.color = userTheme;
            sessionStorage.setItem("__ADMINTO_CONFIG__", JSON.stringify(saved));
        }
    } else {
        // No DB preference: check OS preference, then fall back to default
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            config['theme'] = 'dark';
        } else if (savedConfig !== null) {
            config['theme'] = JSON.parse(savedConfig).theme || defaultConfig.theme;
        } else {
            var layoutColor = html.getAttribute('data-bs-theme');
            config['theme'] = layoutColor !== null ? layoutColor : defaultConfig.theme;
        }
    }

    var layoutSize = html.getAttribute('data-layout-mode');
    config['layout']['mode'] = layoutSize !== null ? layoutSize : defaultConfig.layout.mode;

    var topbarColor = html.getAttribute('data-topbar-color');
    config['topbar']['color'] = topbarColor != null ? topbarColor : defaultConfig.topbar.color;

    var leftbarSize = html.getAttribute('data-sidenav-size');
    config['sidenav']['size'] = leftbarSize !== null ? leftbarSize : defaultConfig.sidenav.size;

    var menuColor = html.getAttribute('data-menu-color');
    config['menu']['color'] = menuColor !== null ? menuColor : defaultConfig.menu.color;

    window.defaultConfig = JSON.parse(JSON.stringify(config));

    // Merge non-theme settings from sessionStorage if available
    if (savedConfig !== null) {
        var savedObj = JSON.parse(savedConfig);
        if (savedObj.layout) config.layout.mode = savedObj.layout.mode || config.layout.mode;
        if (savedObj.topbar) config.topbar.color = savedObj.topbar.color || config.topbar.color;
        if (savedObj.sidenav) config.sidenav.size = savedObj.sidenav.size || config.sidenav.size;
        if (savedObj.menu) config.menu.color = savedObj.menu.color || config.menu.color;
    }

    window.config = config;

    if (config) {

        if (window.innerWidth <= 1140) {
            html.setAttribute("data-sidenav-size", "full");
            html.setAttribute("data-layout-mode", "default");
        } else {
            html.setAttribute("data-layout-mode", config.layout.mode);
            html.setAttribute("data-sidenav-size", config.sidenav.size);
        }

        html.setAttribute("data-bs-theme", config.theme);
        html.setAttribute("data-menu-color", config.menu.color);
        html.setAttribute("data-topbar-color", config.topbar.color);

    }
})();